import React from 'react';
import PropTypes from 'prop-types';
import Tag from 'chameleon/ui-stack/ui/base/tag';
import TagWithIcon from 'chameleon/ui-stack/ui/tags/tag-with-icon';

const Title = ({ children, isAlert, onClick, accessibility }) => {
  const Component = onClick ? TagWithIcon : Tag;

  const componentProps = {
    isFullWidth: true,
    isSecondary: !isAlert,
    isAlert,
    accessibility,
  };

  if (onClick) {
    componentProps.icon = 'times';
    componentProps.iconOrientation = 'right';
    componentProps.onClick = onClick;
    componentProps.btnAccessibility = {
      'aria-label': 'Remove',
    };
  }

  return <Component {...componentProps}>{children}</Component>;
};

Title.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  isAlert: PropTypes.bool,
  onClick: PropTypes.func,
  accessibility: PropTypes.shape({
    title: PropTypes.string,
    'aria-label': PropTypes.string,
    'aria-labelledby': PropTypes.string,
  }),
};

Title.defaultProps = {
  isAlert: false,
  onClick: null,
  accessibility: {
    title: null,
    'aria-label': null,
    'aria-labelledby': null,
  },
};

export default Title;
